<template>
  <div
    class="flex flex-wrap items-center gap-[8px] px-[12px] pb-[10px] pt-[12px]">
    <refonte-table-number
      v-if="props.total_elements || props.total_elements == 0"
      v-bind:number="props.total_elements"
      v-bind:label="`${props.total_elements > 1 ? 'Formations' : 'Formation'}`" />
  </div>
  <refonte-separator class="px-[12px]" />
</template>

<script setup lang="ts">
  import RefonteTableNumber from '@/components/refonte/numbers/refonte-table-number.vue';
  import RefonteSeparator from '@/components/refonte/separators/refonte-separator.vue';

  const props = withDefaults(
    defineProps<{
      total_elements?: number;
    }>(),
    {}
  );
</script>

<style lang="scss" scoped></style>
